import React from 'react';
import '../styles/Home.css';

const Home = () => {
  return (
    <article className="home-container" itemScope itemType="https://schema.org/SoftwareApplication">
      <meta itemProp="name" content="Tó Túra by Szürkebarát" />
      <meta itemProp="operatingSystem" content="iOS, Android" />
      <meta itemProp="applicationCategory" content="HealthApplication" />

      <div className="screenshot-background">
        <img
          src="/screenshot.png"
          alt="Tó Túra by Szürkebarát alkalmazás képernyőképe - GPS túra a Balaton, Tisza-tó és Velencei-tó körül"
          className="screenshot-img"
          loading="eager"
          width="390"
          height="844"
          itemProp="screenshot"
        />
      </div>

      <header className="hero-content">
        <h1 className="hero-title">Fedezd fel Európa tavait a saját tempódban</h1>
        <p className="hero-subtitle" itemProp="description">
          Töltsd le a <strong>Tó Túra by Szürkebarát</strong> appot, teljesíts kihívásokat Magyarország tavainál és szerezz jutalmakat.
          Sétálj, kerékpározz vagy fuss a Balaton, Tisza-tó és Velencei-tó körül, gyűjts érmeket és kerülj fel a toplistára!
        </p>
      </header>

      <nav className="mini-footer-content" aria-label="Alkalmazás letöltése">
        <div className="download-buttons">
          <a
            href="https://apps.apple.com/us/app/t%C3%B3-t%C3%BAra-by-sz%C3%BCrkebar%C3%A1t/id6752615113"
            target="_blank"
            rel="noopener noreferrer"
            className="store-icon apple-icon"
            aria-label="Letöltés az App Store-ból"
            itemProp="downloadUrl"
          >
            <svg width="50" height="50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M14.94 5.19A4.38 4.38 0 0 0 16 2a4.44 4.44 0 0 0-3 1.52 4.17 4.17 0 0 0-1 3.09 3.69 3.69 0 0 0 2.94-1.42m2.52 7.44a4.51 4.51 0 0 1 2.16-3.81 4.66 4.66 0 0 0-3.66-2c-1.56-.16-3 .91-3.83.91s-2-.89-3.3-.87a4.92 4.92 0 0 0-4.14 2.53C2.93 12.45 4.24 17 6 19.47c.8 1.21 1.8 2.58 3.12 2.53s1.75-.82 3.28-.82 2 .82 3.3.79 2.22-1.24 3.06-2.45a11 11 0 0 0 1.38-2.85 4.41 4.41 0 0 1-2.68-4.04"/>
            </svg>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.szurkebarat.toturak&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="store-icon google-icon"
            aria-label="Letöltés a Google Play-ről"
            itemProp="downloadUrl"
          >
            <svg width="50" height="50" viewBox="-6.5 -0.016 100.001 100.001" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="m49.997 47.153 12.778-12.779C39.436 20.552 4.949.274 3-.016L2.844 0zM.016 2.829 0 2.984v94l.015.149 47.153-47.152zm49.987 49.987L2.852 99.968l.148.017c1.958-.312 36.439-20.58 59.775-34.396zM84 46.984s-7.372-4.398-17.665-10.5L52.832 49.988l13.497 13.497C76.625 57.382 84 52.984 84 52.984c1.607-.844 3-1.343 3-3 0-1.656-1.584-2.225-3-3"/>
            </svg>
          </a>
        </div>
        <div className="copyright">
          <span itemProp="author" itemScope itemType="https://schema.org/Organization">
            © <span itemProp="name">Szürkebarát</span>
          </span>
        </div>
      </nav>
    </article>
  );
};

export default Home;